import { createElement } from 'react';

const SvgChevronLeft = (props) => (createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 8 16", fill: "none" }, props),
    createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M.203 8.538a.805.805 0 010-1.068L6.518.287a.858.858 0 011.188-.09.806.806 0 01.091 1.157l-5.846 6.65 5.846 6.641a.806.806 0 01-.09 1.157.858.858 0 01-1.188-.088L.203 8.538z", fill: "currentColor" })));

export default SvgChevronLeft;
